<template>
    <header>
        <div class="header">
            <div class="header-top">
                <div class="inner">
                    <ul class="header-top__left">
                        <li>
                            <a href="">의료원</a>
                        </li>
                        <li>
                            <a href="">이대목동병원</a>
                        </li>
                        <li>
                            <a href="">이대서울병원</a>
                        </li>
                        <li>
                            <a href="">이대뇌혈관병원</a>
                        </li>
                        <li>
                            <a href="">이대엄마아기병원</a>
                        </li>
                        <li>
                            <a href="">이대여성암병원</a>
                        </li>
                        <li>
                            <a href="">이대비뇨기과병원</a>
                        </li>
                    </ul>
                    <ul class="header-top__right">
                        <li>
                            <router-link to="/kr/reserve/reserve" class="main-button c-main">외래진료 예약</router-link>
                        </li>
                        <li>
                            <a href="https://seoul.eumc.ac.kr/wellness/reservation/reservation.do" target="_blank" class="main-button c-sub">건강검진 예약</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="header-bottom">
                <div class="inner">
                    <h1 class="logo">
                        <a href="/">
                            <img src="@/assets/resource/icon/logo.svg" alt="">
                        </a>
                    </h1>
                    <div class="header-menu-wrap" @mouseover="activateSubMenu" @mouseleave="deactivateSubMenu">
                        <ul class="header-menu" >
                            <template v-for="(menu, idx) in menuList" :key="menu">
                                <li :class="{'header-menu__item': true, 'active': selectedMenu.menuNo == menu.menuNo}" v-if="menu.depth == 1 && menu.gnbYn=='Y'" @mouseover="setParent(menu)">
                                    <component :is="menu.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="menu.menuUrl" :to="menu.menuUrl" :target="menu.linkMethod" class="header-menu--main-link">
                                        <h3>{{menu.menuName}}</h3>
                                    </component>                                    
                                </li>
                            </template>
                        </ul>
                        <slide-up-down :active="isSubMenuActive" :class="{ active: isSubMenuActive }" class="header-sub-menu">
                            <div class="inner">
                                <div class="header-sub-menu__left">
                                    <h3 class="title01">{{selectedMenu.menuName}}</h3>
        
                                    <!-- 병원소개 -->
                                    <template v-if="selectedMenu.menuNo == '1'">
                                        <sub>
                                            산모와 아기의 안전을 최우선으로 여기는 <br>
                                            이대엄마아기병원을 소개합니다.
                                        </sub>
                                        <h4 class="title02">의료진 검색</h4>
                                        <div class="header-sub-menu__left-search">
                                            <input type="text" placeholder="의료진을 검색해주세요." v-model="drName" @keyup.enter="goDoctor()">
                                            <a href="javascript:;" class="main-button c-main" @click="goDoctor">검색</a>
                                        </div>
                                    </template>
        
                                    <!-- 진료예약 -->
                                    <template v-if="selectedMenu.menuNo == '2'">
                                        <h4 class="title02">첫 진료 예약/ 알림톡 서비스</h4>
                                        <div class="header-sub-menu__left__reservation">
                                            <input type="text" placeholder="성함">
                                            <input type="text" placeholder="휴대전화번호">
                                        </div>
                                        <div class="header-sub-menu__left__reservation-btn">
                                            <a href="" class="main-button c-sub">예약 신청</a>
                                            <a href="" class="main-button c-main">알림톡 서비스<br>(진료예약)</a>
                                        </div>
                                        <sub>
                                            전문 상담사가 첫 진료 환자 예약을 도와드립니다. <br>
                                            상담시간 : 평일 09:00 – 17:00 (토요일,공휴일 제외)
                                        </sub>
                                        <sub class="sub-bottom font-main">
                                            * 알림톡 서비스는 24시간 진료예약, 변경/취소, 증명서 발급이
                                            가능합니다.
                                        </sub>
                                    </template>

                                    <!-- 이용안내 -->
                                    <template v-if="selectedMenu.menuNo == '3'">
                                        <sub>
                                            이대엄마아기병원에서 제공드리는<br>
                                            여러 서비스를 안내해드립니다.
                                        </sub>
                                        <h4 class="title03">진료시간</h4>
                                        <ul class="time">
                                            <li class="title">평일</li>
                                            <li class="text">
                                                08:30~12:00 <br>
                                                13:00 ~ 17:00
                                            </li>
                                        </ul>
                                        <ul class="time">
                                            <li class="title">토요일</li>
                                            <li class="text">
                                                09:00 ~ 12:00
                                            </li>
                                        </ul>
                                        <h4 class="title03">해피콜센터</h4>
                                        <h5 class="title01 call">1522-7000</h5>
                                    </template>
                                    
                                     <!-- 행사신청 -->
                                     <template v-if="selectedMenu.menuNo == '4'">
                                        <sub>
                                            이대엄마아기병원에서 진행하는 <br>
                                            행사 내용 및 신청을 안내드립니다.
                                        </sub>
                                    </template>

                                     <!-- 후원안내 -->
                                     <template v-if="selectedMenu.menuNo == '5'">
                                        <sub>
                                            아기와 엄마의 이름으로 기부를 통해 <br>
                                            사랑과 마음을 전해주세요.
                                        </sub>
                                    </template>
        
                                    <!-- 엄마아기정보 -->
                                    <template v-if="selectedMenu.menuNo == '6'">
                                        <sub>
                                            이대엄마아기병원에서 분만과정 및 <br>
                                            산후 아기관리를 안내해드립니다.
                                        </sub>
                                    </template>
                                </div>

                                <ul class="header-menu-list">
                                    <template>
                                        <li class="header-menu-item" v-for="(menu, idx) in subList" :key="menu">
                                            <h4 class="title03">
                                                <component :is="menu.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="menu.menuUrl" :to="menu.menuUrl" :target="menu.linkMethod">
                                                    {{menu.menuName}}
                                                </component>
                                            </h4>
                                            <ul class="header-sub-menu-list" v-if="menu.subList">
                                                <li class="header-sub-menu-item" v-for="sub in menu.subList">
                                                    <component :is="sub.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="sub.menuUrl" :to="sub.menuUrl" :target="sub.linkMethod">
                                                        {{sub.menuName}}
                                                    </component>
                                                </li>
                                            </ul>
                                        </li>
                                    </template>
                                </ul>
                                <ul class="header-sub-menu__right">
                                    <li class="header-sub-menu__right__item">
                                        <a href="">
                                            <img src="@/assets/resource/img/test/header-sub-menu__right__item-test.svg" alt="">
                                            <h4 class="title">입원안내</h4>
                                        </a>
                                    </li>
                                    <li class="header-sub-menu__right__item">
                                        <a href="">
                                            <img src="@/assets/resource/img/test/header-sub-menu__right__item-test.svg" alt="">

                                            <h4 class="title">자연분만</h4>
                                        </a>
                                    </li>
                                    <li class="header-sub-menu__right__item">
                                        <a href="">
                                            <img src="@/assets/resource/img/test/header-sub-menu__right__item-test.svg" alt="">

                                            <h4 class="title">제왕절개</h4>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </slide-up-down>
                    </div>
                    <ul class="header-bottom__right">
                        <template v-if="!$store.state.memberStore.status">
                            <li class="login">
                                <router-link to="/kr/login">로그인</router-link>
                            </li>
                            <li class="member">
                                <router-link to="/kr/join">회원가입</router-link>
                            </li>
                        </template>
                        <template v-else>
                            <li class="login02">
                                <a href="javascript:;" @click="logout">로그아웃</a>
                            </li>
                            <li class="member02">
                                <router-link to="/kr/mypage/mypage">내 진료 정보</router-link>
                            </li>
                        </template>
                        <li>
                            <div class="header-select">
                                <a href="javascript:;" class="header-select--btn" :class="{ active: isSelectActive }" @click.prevent="activeSelect">KOR</a>
                                <slide-up-down :active="isSelectActive" class="header-option">
                                    <div class="header-option-inner">
                                        <a href="/en/main" target="_blank" class="header-option--btn">English</a>
                                        <a href="/ru/main" target="_blank" class="header-option--btn">Russian</a>
                                        <a href="/mn/main" target="_blank" class="header-option--btn">Mongolian</a>
                                        <a href="/ar/main" target="_blank" class="header-option--btn">Arabic</a>
                                        <a href="/zh/main" target="_blank" class="header-option--btn">Chinese</a>
                                    </div>
                                </slide-up-down>
                            </div>
                        </li>
                        <li>
                            <a href="" class="header-search" @click.prevent="activesearch"></a>
                        </li>
                        <li>
                            <a href="" class="header-total-menu" @click.prevent="activemap"></a>
                        </li>
                    </ul>
                </div>
            </div>
            <slide-up-down :active="mapActive"class="site-map" :class="{ active: mapActive }">
                <div class="inner">
                    <ul class="site-map__list">
                        <template v-for="one in menuList">
                            <li class="site-map__item" v-if="one.depth == 1 && one.gnbYn == 'Y'">
                                <h3 class="title01">{{one.menuName}}</h3>
                                <ul class="site-map__deps2-list">
                                    <template v-for="two in menuList">
                                        <li class="site-map__deps2-item" v-if="two.gnbYn == 'Y' && one.menuNo == two.parentMenuNo">
                                            <component :is="two.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="two.menuUrl" :to="two.menuUrl" :target="two.linkMethod" class="title02" @click.prevent="activemap">
                                                {{two.menuName}}
                                            </component>
                                            <ul class="site-map__deps3-list">
                                                <template v-for="three in menuList">
                                                    <li class="site-map__deps3-item" v-if="three.gnbYn == 'Y' && two.menuNo == three.parentMenuNo">
                                                        <component :is="three.linkMethod.indexOf('blank') > -1 ? 'a' : 'router-link'" :href="three.menuUrl" :to="three.menuUrl" :target="three.linkMethod" @click.prevent="activemap">
                                                            {{three.menuName}}
                                                        </component>
                                                    </li>
                                                </template>
                                            </ul>
                                        </li>
                                    </template>
                                </ul>
                            </li>
                        </template>
                    </ul>
                </div>
            </slide-up-down>
            <div class="popup" :class="{ active: isSearchActive }">
                <div class="total-search-wrap">
                    <a href="" class="total-search--close" @click.prevent="activesearch"></a>
                    <div class="total-search">
                        <input type="text" class="total-search--input" placeholder="검색어를 입력해주세요">
                        <a href="" class="total-search--btn"></a>
                    </div>
                    <ul class="total-search__list">
                        <li class="total-search__item"><a href="">#진료의료</a></li>
                        <li class="total-search__item"><a href="">#면회안내</a></li>
                        <li class="total-search__item"><a href="">#응급실안내</a></li>
                        <li class="total-search__item"><a href="">#비급여 진료비</a></li>
                        <li class="total-search__item"><a href="">#진료일정</a></li>
                        <li class="total-search__item"><a href="">#실손보험</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';

export default {
    components: {
        SlideUpDown,
    },
    data(){
        return {
            isSelectActive: false,
            isSearchActive: false,
            mapActive: false,
            isSubMenuActive: false,
            subList: [],
            selectedMenu: '',
            drName: '',
            title: '',
        };
    },
    methods: {
        goDoctor(){
            if(!this.drName){
                alert('의료진명을 입력해주시길 바랍니다.')
                return
            }
            if(this.drName.length < 2){
                alert('2글자 이상 입력해주시길 바랍니다.')
                return
            }
            this.$router.push(`/kr/doctorList?drName=${this.drName}`)
        },
        goArticle(){
            if(!this.title){
                alert('질환 정보를 입력해주시길 바랍니다.')
                return
            }
            this.$router.push(`/kr/aorta_health_dic/list?title=${this.title}`)
        },
        setParent(menu){
            this.selectedMenu = menu
            const parentNo = menu.menuNo ? menu.menuNo : 1
            this.setMenuList(parentNo)
        },
        setMenuList(parentMenuNo){
            this.subList = this.menuList.filter(i => i.parentMenuNo == parentMenuNo && i.depth == '2' && i.gnbYn == 'Y')

            for(let i of this.subList){
                i.subList = this.menuList.filter(j => j.parentMenuNo == i.menuNo && j.gnbYn == 'Y')
            }
        },
        logout() {
            this.axios
                .get(this.api.member.logout)
                .then((res) => {
                    // console.log(res)
                })
                .catch(err => {
                    console.log(err);
                });
            this.$store.commit("setStatus", false);
            location.reload();
        },
        activeSelect() {
            this.isSelectActive = !this.isSelectActive;
        },
        activesearch() {
            this.isSearchActive = !this.isSearchActive;
        },
        activemap() {
            this.mapActive = !this.mapActive;
        },
        activateSubMenu(index) {
            this.isSubMenuActive = true;
        },
        deactivateSubMenu() {
            this.isSubMenuActive = false;
            this.selectedMenu = ''
        },
    },
    mounted() {
        
    },
    beforeUnmount() {
    }
};
</script>